import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModalHeader from '../common/modal/header';
import ModalFooter from '../common/modal/footer';
import ProductSuggestion from './product-suggestion';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;
class ProductSuggestionsWarning extends React.Component {
    static propTypes = {
        product_suggestions: PropTypes.arrayOf(
            PropTypes.shape({
                action: PropTypes.string,
                is_free: PropTypes.bool,
                category: PropTypes.shape({
                    category_product: PropTypes.shape({
                        id: PropTypes.number,
                        name: PropTypes.string,
                    }),
                    quantity: PropTypes.number,
                    discount: PropTypes.string,
                }),
                product: PropTypes.shape({
                    menu_product: PropTypes.shape({
                        id: PropTypes.number,
                        name: PropTypes.string,
                    }),
                    quantity: PropTypes.number,
                    discount: PropTypes.string,
                }),
            })
        ),
        closeModal: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    onCloseButtonClick = () => {
        this.props.closeModal();
    };

    onSkipButtonClick = () => {
        const { product_suggestions, closeModal } = this.props;
        closeModal(true);
        UI.trigger('progressForward', 'preconfirmation_warning');
        Order.log('preconfirmation warning product suggestion ignored', {
            product_suggestions,
        });
    };

    render() {
        const are_all_free = _.every(this.props.product_suggestions, s => s.is_free);
        const { t } = this.props;
        return (
            <div className="m2g-preconfirmation-warning">
                <ModalHeader
                    headerText={are_all_free ? t('add_for_free'): t('add_to_order')}
                    onClose={this.onCloseButtonClick}
                />
                <div className="m2g-modal-body m2g-preconfirmation-warning-product-suggestions">
                    {this.props.product_suggestions.map((suggestion, i) => (
                        <ProductSuggestion
                            key={i}
                            {...suggestion}
                            closeModal={this.props.closeModal}
                            all_suggestions_count={
                                this.props.product_suggestions.length
                            }
                        />
                    ))}
                </div>
                <ModalFooter>
                    <ModalFooter.Right>
                        <button
                            onClick={this.onSkipButtonClick}
                            className="m2g-button"
                        >
                            {t('skip')}
                        </button>
                    </ModalFooter.Right>
                </ModalFooter>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.preconfirmation-warning')(
    ProductSuggestionsWarning
);
